'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const SocialNaverOriginalAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M18 2H6C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.71429 2C2.52827 2 2.36272 2.07068 2.21763 2.21205C2.07254 2.35342 2 2.52083 2 2.71429V21.2857C2 21.4791 2.07254 21.6466 2.21763 21.7879C2.36272 21.9293 2.52827 22 2.71429 22H21.2857C21.4717 22 21.6373 21.9293 21.7824 21.7879C21.9275 21.6466 22 21.4791 22 21.2857V2.71429C22 2.52083 21.9275 2.35342 21.7824 2.21205C21.6373 2.07068 21.4717 2 21.2857 2H2.71429ZM6.47546 7H10.3259L13.6741 12V7H17.5245V17H13.6741L10.3259 12V17H6.47546V7Z",
          fill: "#00BF18"
        }
      )
    ]
  }
);
const VpSocialNaverOriginalAsset = forwardRef(SocialNaverOriginalAsset);

export { VpSocialNaverOriginalAsset as default };
